import { createSelector } from "redux-starter-kit";

export default createSelector(
  ["auth.email"],
  (email: any): any => email
);
